import axios from 'axios';
import { Api_Url, Api_Version } from '../config/Constants';
import { sendAmplitudeData } from './amplitude';
import { removeToken } from './utils';

const URL = `${Api_Url}/${Api_Version}`;

const http = axios.create({
  baseURL: URL,
  headers: {
    'Content-type': 'application/json',
  },
});

// set token
export const setHttpToken = (token) => {
  http.defaults.headers.common.Authorization = `Bearer ${token}`;
};

// remove token
export const removeHttpToken = () => {
  delete http.defaults.headers.common.Authorization;
};

// set latest build in each request
http.interceptors.request.use(
  (config) => {
    const latestBuild = localStorage.getItem('latest_build');
    if (latestBuild) {
      config.headers.build = latestBuild;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// check every axios response
http.interceptors.response.use(
  (response) => {
    const reloadFlag = response.headers?.reload_flag;
    const latestBuild = response.headers?.latest_build;

    if (latestBuild) {
      localStorage.setItem('latest_build', latestBuild);
    }

    if (reloadFlag === '1') {
      window.location.reload();
    }

    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/';
      localStorage.removeItem('persist:root');
      removeToken();
    }
    return Promise.reject(error);
  }
);

export const httpGet = async (url, config) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await http.get(url, config);
    return res;
  } catch (err) {
    const event = 'API Error';
    const eventProperties = {
      url,
      error: err,
    };
    sendAmplitudeData(event, eventProperties);
    throw err;
  }
};

export const httpPost = async (url, data, config) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await http.post(url, data, config);
    return res;
  } catch (err) {
    const event = 'API Error';
    const eventProperties = {
      url,
      error: err,
    };
    sendAmplitudeData(event, eventProperties);
    throw err;
  }
};

export const httpPut = async (url, data, config) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await http.put(url, data, config);
    return res;
  } catch (err) {
    const event = 'API Error';
    const eventProperties = {
      url,
      error: err,
    };
    sendAmplitudeData(event, eventProperties);
    throw err;
  }
};

export const httpDelete = async (url, config) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await http.delete(url, config);
    return res;
  } catch (err) {
    const event = 'API Error';
    const eventProperties = {
      url,
      error: err,
    };
    sendAmplitudeData(event, eventProperties);
    throw err;
  }
};

export default http;
